import React from "react";

/**
 * Stand-in for a money figure that needs an exchange rate we don't have.
 *
 * FX RULE (hooks/fx.js): a figure is never computed with a guessed rate. With
 * no known rate the figure is replaced by this. `unavailable` = the rate
 * request failed ("Rate unavailable"); otherwise it is still loading ("…").
 */
const FxUnavailable = ({ unavailable = true }) =>
  unavailable ? (
    <span
      className="text-muted fx-unavailable"
      title="Exchange rate unavailable, so this figure can't be converted right now. Try again shortly."
    >
      Rate unavailable
    </span>
  ) : (
    <span className="text-muted fx-unavailable">…</span>
  );

export default FxUnavailable;
